<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getShipment,
  refShipments,
  exportOutBound,
  getTags,
  createBill,
  cancelHang,
  uploadFile,
  getConfig,
  client,
  client_hq,
  sync,
  branchOffice,
  setJiYun,
  updateWeightFinance,
	newGetList
} from "@/api/finance/shipment_hq";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getContractParams } from "@/api/user/contract";
import { getCountry } from "@/api/system/country";
import { getUser } from "@/api/user/internal";

import cTable from "@/base/common/index";
export default {
  name: "shipment_hq",
  components: {
    cTable
  },
  data() {
    return {
      client_hq_list: [],
      hq_clients: [],
      methods: {
        list: data => {
					console.log(this.hq_clients);
          let params = JSON.parse(JSON.stringify(data));
          if (data.hq_client) {
            params.hq_client = this.client_hq_list.reduce((a, b) => {
              this.hq_clients.find(t => {
                if (t.value === b.uuid && t.label === b.account) {
                  a.push(b);
                  return true;
                }
              });
              return a;
            }, []);
          }
          return newGetList(params);
        },
        refShipments,
        exportOutBound,
        getAllClient,
        getTags,
        getContractParams,
        cancelHang,
        uploadFile,
        client,
        sync,
        branchOffice,
        setJiYun,
        updateWeightFinance,
        beforeHandleList({ data }) {
          // if (!this.pushTableTitle) {
          //   let obj = {
          //     name: this.$t("cost_fee"),
          //     children: []
          //   };
          //   let newObj = data.rows[0].cost_name;
          //   Object.keys(newObj).forEach(key => {
          //     this.pushTableTitle = true;
          //     let data = {
          //       name: newObj[key],
          //       key: key,
          //       minWidth: 145,
          //       methods: {
          //         render({ row }) {
          //           return row.cost[key].toString();
          //         }
          //       }
          //     };
          //     obj.children.push(data);
          //   });
          //   this.fields.push(obj);
          // }
          return;
        },
        createBill,
        getConfig
      },
      config: {
        height: 630,
        contentMethod({ row, column }) {
          if (column.type == "status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        }
      },
      modals: {
        reStatistics: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = this.$page.selectAll.map(item => ({
                target_type: item.target_type,
                airway_bill_number: item.airway_bill_number
              }));
              this.$page
                .handleRequestMethods("refShipments", data)
                .then(res => {
                  this.loadingConfirm = false;
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("reStatistics"),
            modalBind: {
              width: 400
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ use_charge_type: 24 }],
          fields: [
            {
              name: this.$t("Billing") + this.$t("type"),
              key: "use_charge_type",
              component: "Radio",
              placeholder: () =>
                this.$t("select") + this.$t("Billing") + this.$t("type"),
              options: [],
              bind: {
                border: true
              },
              default: "charge_params",
              methods: {
                async list({ field }) {
                  field.options = (await getConfig()).data.payload.weight_type;
                  this.$forceUpdate();
                }
              }
            }
          ]
        },
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl + "/excel/tmp/charge_weight_finance.xlsx"
              );
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        },
        add: {
					type:'add',
          methods: {
            ok: ({ row, close }) => {
              let data = JSON.parse(JSON.stringify(row));
              let table = this.$refs["table"];
              data.ids = table.selectAll.map(item => item.airway_bill_number);
              if (data.hq_client) {
                data.hq_client = this.client_hq_list.reduce((a, b) => {
                  this.hq_clients.find(t => {
                    if (t.value === b.uuid && t.label === b.account) {
                      a.push(b);
                      return true;
                    }
                  });
                  return a;
                }, []);
              }
              table
                .handleRequestMethods("createBill", data, false, true)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  table.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { name: 24 },
            { show_sku: 24 },
            { target_type: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("whether") + this.$t("show") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show") +
                "SKU",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              default: 0,
              bind: {
                border: true
              }
            },
            {
              name: this.$t("CollectionUser"),
              key: "target_type",
              component: "Radio",
              placeholder: () => this.$t("select") + this.$t("CollectionUser"),
              options: [
                { label: this.$t("b2bClient"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        feeModal: {
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 800
            },
            modalContentBind: {
              style: {
                height: "600px"
              }
            }
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("expense"),
                key: "expense_item_name"
              },
              {
                name: () => this.$t("cost_t") + "(USD)",
                key: "amount_usd"
              },
              {
                name: () => this.$t("cost_t") + "(CNY)",
                key: "amount_cny"
              },
              {
                name: () => this.$t("createUser"),
                key: "operator_name"
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                width: 170
              }
            ]
          },
          footer: {
            show: () => false
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            options: [
              { label: this.$t("outbound_time"), value: 2 },
              {
                label: this.$t("inboundTime"),
                value: 3
              }
            ],
            bind: {
              style: "width:150px"
            },
            default: 2
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          // {
          //   key: "client_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   default: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:200px",
          //     multiple: true,
          //     "max-tag-count": 1
          //   }
          // },
          {
            key: "hq_client",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("HQClient");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "account", value: "uuid" },
            bind: {
              style: "width:200px",
              multiple: true,
              "max-tag-count": 1,
              "label-in-value": true
            },
            methods: {
              "on-change": data => {
                this.hq_clients = data._value;
              }
            }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          // {
          //   key: "ownership",
          //   placeholder() {
          //     return this.$t("select") + this.$t("ownership");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "title",
          //     value: "id"
          //   }
          // },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
						default:1,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 }
            ]
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("billingStatus");
            },
            clearable: true,
            options: [
              { label: this.$t("billFailed"), value: 0 },
              {
                label: this.$t("billSuccess"),
                value: 1
              }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("bill_type");
            },
            clearable: true,
            options: [
              { label: this.$t("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "c_title",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("contract_title");
            },
            clearable: true,
            options: [],
            config: {
              label: "title",
              value: "id"
            },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "countryCode",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: {
              label: "code",
              value: "code"
            },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "use_charge_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("Billing") + this.$t("type");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (await getConfig()).data.payload.weight_type;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "tag",
            component: "Select",
            placeholder() {
              return this.$t("select") + "Tags";
            },
            clearable: true,
            options: [],
            config: {
              label: "value",
              value: "key"
            },
            bind: {
              style: "width:220px",
              multiple: true,
              "max-tag-count": 1
            }
          },
          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            clearable: true,
            options: [
              { label: this.$t("orderNum"), value: "1" },
              { label: this.$t("packing_number"), value: "2" },
              { label: this.$t("mawb"), value: "3" }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("reStatistics"),
              type: "reStatistics",
              fnName: "reStatistics",
              bind: {
                type: "warning",
                icon: "md-refresh"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("ImportCargo"),
              type: "ImportCargo",
              fnName: "uploadFile",
              component: "Upload",
              data: "setJiYun",
              bind: {
                type: "primary",
                showUploadList: false
              },
              upBind: {
                accept: ".xlsx,.xls"
              }
            },
            {
              name: () => this.$t("update") + this.$t("charge_params1"),
              type: "changeWeight",
              fnName: "uploadFile",
              data: "updateWeightFinance",
              component: "Upload",
              bind: {
                type: "primary",
                showUploadList: false
              },
              upBind: {
                accept: ".xlsx,.xls"
              }
            },
            {
              name: () => this.$t("cancel") + this.$t("hang"),
              type: "cancelHang",
              fnName: "cancelHang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-arrow-down",
                type: "warning"
              }
            },
            /* 
            {
              name: () =>
                this.$t("update") +
                this.$t("Billing") +
                this.$t("invoiceWeight"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "warning"
              },
              id: 862
            },
             */
						{
						  name: () => this.$t("export"),
						  type: "export",
						  fnName: "export",
						  disabled() {
						    return !this.selectAll.length;
						  },
						  bind: {
						    icon: "md-arrow-down",
						    type: "primary"
						  },
						},
            {
              name: this.$t("export") + this.$t("ShipmentDetails"),
              bind: {
                type: "primary"
              },
              fnName: "export"
            },
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary"
              },
              id: 1062
            }
          ],
          methods: {
            uploadFile({ file, field }) {
              let formData = new FormData();
              formData.append("file", file);
              this.$page
                .handleRequestMethods(field.data, formData, true, true)
                .then(res => {
                  this.$page.getList();
                });
              return false;
            },
            sync() {
              this.handleRequestMethods("sync").then(res => {
                this.getList();
              });
            },
            upload() {
              this.getModal("upload").open();
            },
            add({ searchForm }) {
              this.getModal("add").open(searchForm);
            },
            export({ searchForm }) {
              // this.openLoading();
              // let data = searchForm;
              // data.export = 1;
              // this.handleRequestMethods("list", data, false, true).then(res => {
              //   window.open(this.$globalUrl + res.payload.src, "_blank");
              //   this.closeLoading();
              // });
							this.exportExc()
            },
            cancelHang() {
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    ids: this.selectAll.map(item => {
                      return item.id;
                    })
                  };
                  this.handleRequestMethods("cancelHang", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            reStatistics() {
              this.getModal("reStatistics").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
          fixed: "left"
        },
        // {
        //   name: () => this.$t("packing_number"),
        //   key: "packing_number",
        //   minWidth: 130
        // },
        {
          name: () => this.$t("CollectionUser"),
          key: "target_type_txt",
          width: 100
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 130
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 130
        },
        {
          name: () => this.$t("trajectory"),
          children: [
            {
              name: () => this.$t("code"),
              key: "trace_code",
              width: 95,
              methods: {
                render: ({ row }) => {
                  return row.shipment ? row.shipment.trace_code : "-";
                }
              }
            },
            {
              name: () => this.$t("newest") + this.$t("deSc"),
              key: "trace_remarks",
              width: 110,
              methods: {
                render: ({ row }) => {
                  return row.shipment ? row.shipment.trace_remarks : "-";
                }
              }
            },
            // {
            //   name: () => this.$t("tracker_description_cn"),
            //   key: "status_cn",
            //   minWidth: 100,
            //   methods: {
            //     render: ({ row }) => {
            //       return row.shipment ? row.shipment.status_cn : "-";
            //     }
            //   }
            // },
            {
              name: () => this.$t("update") + this.$t("time"),
              key: "shipment.trace_time",
              width: 170,
             
            }
          ]
        },
        {
          name: () => this.$t("bill_type"),
          key: "finance_status_txt",
          width: 80,
          methods: {
            render({ row }) {
              return row.finance_status_txt;
            }
          }
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill.bill_number",
          width: 110,
          render: (h, { row }) => {
            if (row.bill) {
              return h(
                "a",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "bill"
                      });
                      this.$store.dispatch(
                        "pageUrl",
                        row.bill_number
                      );
                    }
                  }
                },
                row.bill.bill_number
              );
            }
          }
        },
        {
          name: () => this.$t("bindFreight"),
          key: "quotation_name",
          align: "left",
          width: 95,
          methods: {
            render({ row }) {
              return row.quotation_name;
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          width: 95,
          methods: {
            render: ({ row }) => {
              return row.clientInfo ? row.clientInfo.account : " - ";
            }
          }
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 160
        },
        {
          name: () => this.$t("contract_title"),
          align: "left",
          key: "main_contract_header_txt",
          width: 110
        },
        // {
        //   name: () => this.$t("salesman"),
        //   width: 95,
        //   key: "salesman",
        //   methods: {
        //     render: ({ row }) => {
        //       return row.clientInfo.salesman
        //         ? row.clientInfo.salesman.account
        //         : " - ";
        //     }
        //   }
        // },

        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          width: 95,
          methods: {
            render({ row }) {
              return row.shipment.transport_mode;
            }
          }
        },
        /* {
          name: this.$t("shipment_place"),
          key: "warehouse",
          minWidth: 100
        }, */
        // {
        //   name: () => this.$t("mawb"),
        //   key: "mawb",
        //   minWidth: 100
        // },
        // {
        //   name: () => this.$t("CTNS") + "(" + this.$t("caseNumber") + ")",
        //   key: "quantity",
        //   minWidth: 100
        // },
        /* {
          name: this.$t("agentT"),
          children: [
            {
              name: () => this.$t("crossPort"),
              key: "packing_agent",
              minWidth: 100
            },
            {
              name: () => this.$t("clearance"),
              key: "clearance_agent",
              minWidth: 100
            },
            {
              name: () => this.$t("air_transport"),
              key: "air_agent",
              minWidth: 100
            },
            // {
            //   name: () => this.$t("delivery"),
            //   key: "shipments",
            //   minWidth: 100,
            //   methods: {
            //     render({ value }) {
            //       return value.deliver;
            //     }
            //   }
            // }
          ]
        }, */
        {
          name: () => this.$t("delivery"),
          key: "deliver",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.shipment.deliver;
            }
          }
        },
				{
				  name: () => this.$t("destination"),
				  children: [
				    {
				      name: () => this.$t("countryCode"),
				      key: "country_code",
				      width: 95,
				      methods: {
				        render({ row }) {
				          return row.shipment.to_country;
				        }
				      }
				    },
				    {
				      name: () => this.$t("city_t"),
				      key: "city_name",
				      width: 95,
				      methods: {
				        render({ row }) {
				          return row.shipment.city_name;
				        }
				      }
				    },
				    {
				      name: () => this.$t("RemoteRegions"),
				      key: "remote_areas",
				      width: 110,
				      methods: {
				        render: ({ row }) => {
				          return row.shipment.remote_areas &&
				            row.shipment.remote_areas != 0
				            ? this.$t("YES")
				            : this.$t("NO");
				        }
				      }
				    }
				  ]
				},
        /* {
          name: () => this.$t("currency_t"),
          children: [
            {
              name: () => this.$t("Collection_t"),
              key: "replace_currency",
              width: 95
            },
            {
              name: () => this.$t("receivable"),
              key: "freight_unit",
              width: 95
            }
          ]
        }, */
        {
          name: this.$t("invoiceWeight"),
          children: [
						{
						  name: () => this.$t("amount_actual"),
						  key: "actual_weight",
						  width: 95,
						  methods: {
						    render({ row }) {
						      return row.actual_weight;
						    }
						  }
						},
            {
              name: () => this.$t("skuVolume"),
              key: "charge_volume",
              width: 95,
              methods: {
                render({ row }) {
                  return row.charge_volume;
                }
              }
            },
            {
              name: () => this.$t("Billing"),
              key: "charge_params",
              width: 95,
              methods: {
                render({ row }) {
                  return row.charge_params;
                }
              }
            },
            {
              name: () => this.$t("Billing") + "(" + this.$t("finances") + ")",
              key: "charge_weight_finance",
              width: 95,
              methods: {
                render({ row }) {
                  return row.charge_weight_finance;
                }
              }
            },
            {
              name: () => this.$t("charge_params") + this.$t("type"),
              key: "use_charge_type",
              width: 110,
              methods: {
                render({ row }) {
                  return row.use_charge_type;
                }
              }
            }
          ]
        },
        ...(['CNY','USD','KWD'].reduce((a,b)=>{
					let oKey = 'chargeInfo.'+b+'.'
					a.push({
						name:b,
						key:b,
						children:[{
							key:oKey+'freight_fees',
							name:this.$t('receivable')+this.$t('freight_fees'),
							width: 110,
						},
						{
							key:oKey+'actual_freight',
							name:this.$t('actual_receipt')+this.$t('freight_fees'),
							width: 110,
						},
						{
							key:oKey+'remote_regions_fee',
							name:this.$t('remote_fee'),
							width: 110,
						},
						{
							key:oKey+'peak_season_fee',
							name:this.$t('epidemic')+this.$t('freight_append'),
							width: 110,
						},
						{
							key:oKey+'other_fee',
							name:this.$t('otherCost'),
							width: 110,
						},
						{
							key:oKey+'sub_total',
							name:this.$t('receivable')+this.$t('subtotal'),
							width: 110,
						},
						{
							key:oKey+'total_tax',
							name:this.$t('total_tax'),
							width: 110,
						}
						]
					})
					a.push({
						name:this.$t('receivableTotal')+`(${b})`,
						key:oKey+'total_amount',
						width:100
					})
					return a
				},[])),
				{
				  name: () => this.$t('DeclaredValue'),
				  key: "values",
				  width: 110,
				},
				{
					name:'COD',
					children:[
						{
							name:this.$t('cod_amount1'),
							key:'cod_amount',
							width: 110,
						},
						{
							name:this.$t('cod_currency'),
							key:'replace_currency',
							width: 110,
						}
					]
				},
				{
					name:this.$t('taxFee')+' USD',
					children:[
						{
							name:this.$t('total_tax'),
							key:'total_tax',
							width: 110,
						},
						{
							name:this.$t('vat_fee')+' VAT',
							key:'vat_fee',
							width: 110,
						},
						{
							name:this.$t('tax_fee')+' Duty',
							key:'tax_fee',
							width: 110,
						},
						{
							name:this.$t('document_fee'),
							key:'document_fee',
							width: 110,
						}
					]
				},
				{
					name:this.$t('to')+this.$t('rate'),
					children:['freight_unit','cny','usd','kwd'].map((t,i)=>{
						return {
							name:i===0?this.$t('toCurrency'):t.toLocaleUpperCase(),
							key:'rateInfo.'+(t+(i===0?'':'_to_rate')),
							width: 110,
						}
					})
				},
        {
          name: () => this.$t("exlType"),
          key: "status",
          fixed: "right",
          type: "status",
          minWidth: 80,
          bind: {
            style({ row }) {
              return {
                color:
                  row.status == "1"
                    ? "#4caf50"
                    : "#f44336"
              };
            }
          },
          methods: {
            render: ({ row }) => {
              return row.status == 0
                ? this.$t("billFailed")
                : this.$t("billSuccess");
            }
          }
        },
        {
          name: () => this.$t('label'),
          key: "tag_txt",
          fixed: "right",
          minWidth: 80
        }
        // {
        //   type: "btns",
        //   width: 150,
        //   name: this.$t("operation"),
        //   fixed: "right",
        //   // width({ field }) {
        //   //   return field.list.length * 40 + 40;
        //   // },
        //   list: [
        //     {
        //       name: this.$t("update"),
        //       type: "update",
        //       fnName: "update",
        //       bind: {
        //         type: "success"
        //       }
        //     },
        //     {
        //       name: this.$t("delete"),
        //       type: "delete",
        //       fnName: "delete",
        //       bind: {
        //         type: "error"
        //       }
        //     }
        //   ],
        //   methods: {
        //     update({ row }) {
        //       this.handleRequestMethods("getDetails", row.id).then(res => {
        //         this.getModal("add").setTitle(this.$t("update"));
        //         this.getModal("add").type = "update";
        //         this.getModal("add").open(res.payload);
        //       });
        //     },
        //     delete({ row }) {
        //       this.$Modal.confirm({
        //         title: this.$t("delete"),
        //         width: 300,
        //         content: this.$t("titleModal"),
        //         onOk: () => {
        //           this.handleRequestMethods("del", row.id).then(res => {
        //             this.$Message["success"]({
        //               background: true,
        //               content: res.msg
        //             });
        //             this.getList();
        //           });
        //         }
        //       });
        //     }
        //   }
        // }
      ]
    };
  },

  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key == "salesman_id") {
        item.options = (
          await getUser({ standard: "Salesman" })
        ).data.payload.rows;
      }
      if (item.key === "hq_client")
        this.client_hq_list = item.options = (await client_hq()).data.payload;
      if (item.key === "tag") item.options = (await getTags()).data.payload;
      if (item.key === "c_title")
        item.options = (await getContractParams()).data.payload.header;
      if (item.key === "countryCode")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  }
};
</script>
